module.exports = __webpack_public_path__ + "static/media/s2.0b9d478e.png";